import { Typography } from "@mui/material";
import { memo } from "react";
import { useTranslation } from "react-i18next";

interface ResendOTPProps {
  timer: number;
  onResend: () => void;
}

const ResendOTP = memo<ResendOTPProps>(({ timer, onResend }) => {
  const { t } = useTranslation("auth");

  // Move formatTime helper inside ResendOTP since it's only used here
  const formatTime = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes < 10 ? "0" : ""}${minutes}:${secs < 10 ? "0" : ""}${secs}`;
  };

  return (
    <div className="tw-text-center tw-mt-4">
      <Typography
        variant="body2"
        className="font-gray-color font-primary font-size-sm tw-leading-6"
      >
        {t("phoneVerification.resend.text")}{" "}
        <span className="tw-font-semibold tw-text-[#000]">
          {formatTime(timer)}{" "}
        </span>
        <button
          onClick={onResend}
          disabled={timer > 0}
          className={`tw-text-sm tw-text-capitalize tw-font-semibold tw-text-[#146C94] ${timer > 0 ? "tw-opacity-50" : ""}`}
        >
          {t("phoneVerification.resend.link")}
        </button>
      </Typography>
    </div>
  );
});

ResendOTP.displayName = "ResendOTP";

export default ResendOTP;
